module.exports = __webpack_public_path__ + "static/media/face_explode_polytope_52_5_3_layers_1_1.66cf9425.gif";